import { mergeAttributes, Node } from '@tiptap/core'

/* Spelled out rather than built by blockAtomNode because the React
 * counterpart renders no `contenteditable` attribute, as with
 * conditions-addressed-block. Routing this through the factory would add one
 * to stored note HTML that the browser never wrote. */
export const MedicationRefillBlockNode = Node.create({
  name: 'medication-refill-block',
  group: 'block',
  atom: true,
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ 'data-type': this.name }, HTMLAttributes)]
  },
})
